import { jsx as _jsx } from "react/jsx-runtime";
import { PromoBlockType } from '../types/entities';
import { getPromoBlockGroups } from './helper';
import PromopanelGroup from './promopanel-group';
import Promoboard from '../promoboard';
import styles from './styles.module.scss';
const Promopanel = ({ promoblocks }) => {
    const promoBlockGroups = getPromoBlockGroups(promoblocks);
    return (_jsx("div", { className: styles.promopanel, "data-testid": "promopanel", children: promoBlockGroups.map((group, index) => {
            if (group.type === PromoBlockType.promoboard) {
                return _jsx(PromopanelGroup, { group: group }, index);
            }
            else {
                return group.blocks.map((promoBlock) => {
                    if (promoBlock.fullWidth) {
                        return _jsx(Promoboard, { promoBlock: promoBlock }, index);
                    }
                    return (_jsx("div", { className: 'container', children: _jsx("div", { className: "row", children: _jsx("div", { className: "col-12", children: _jsx(Promoboard, { promoBlock: promoBlock }) }) }) }, index));
                });
            }
        }) }));
};
export default Promopanel;
